<style lang="scss" scoped>
</style>

<template>
  <div>
    <AlertTips />
    <wxEditor ref="wxEditor"></wxEditor>
    <div class="alignr mt40">
      <el-button type="info" @click="del">删除回复</el-button>
      <el-button type="primary" @click="save">保 存</el-button>
    </div>
  </div>
</template>

<script>
import wxEditor from '@/components/wxEditor';
import AlertTips from '@/components/alertTips';
export default {
  components: {
    wxEditor,
    AlertTips,
  },
  computed: {
    id() {
      return this.$route.params.id;
    },
  },
  data() {
    return {};
  },
  mounted() {
    this.getData();
  },
  methods: {
    async del() {
      let res = await this.$http.delete(
        `/api/${this.id}/autoreply/message/delete`,
      );
      this.$refs.wxEditor.clear();
      this.$message.success('删除成功');
    },
    async getData() {
      let res = await this.$http(`/api/${this.id}/autoreply/message`);
      if (res.replyType) {
        this.$refs.wxEditor.setData(res);
      }
    },
    async save() {
      let v = this.$refs.wxEditor.validate();
      if (v) {
        let obj = this.$refs.wxEditor.postData();
        let res = await this.$http.put(
          `/api/${this.id}/autoreply/message`,
          obj,
        );
        this.$message.success('保存成功');
      }
    },
  },
};
</script>
